<div class="activity-filter-search">
  @if (mobileMode) {
    <app-multiple-input-field
      [fieldConfigs]="[customFieldConfigs[0]]"
      [showSearchButton]="false"
      (inputValuesChanged)="onInputValuesChanged()"
      [formGroup]="formGroup">
    </app-multiple-input-field>

    <app-multiple-input-field [fieldConfigs]="fieldConfigs" (inputValuesChanged)="onInputValuesChanged()" [formGroup]="formGroup">
    </app-multiple-input-field>
  } @else {
    <app-multiple-input-field
      [dateMode]="'future'"
      [fieldConfigs]="fieldConfigs"
      [showSearchButton]="true"
      (inputValuesChanged)="onInputValuesChanged()"
      [formGroup]="formGroup">
    </app-multiple-input-field>
  }
</div>
